export default __webpack_public_path__ + "static/media/location-denied.a62670e2.svg";